<template>
  <ClientOnly>
    <Teleport to=".backdrop-target">
      <div v-if="showModal">
        <LazyLanguageSwitchDialog @close="close" />
      </div>
    </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
const i18n = useI18n()
const { isLocaleRedirectModalOpen, setLocaleRedirectModal } = useUiState()
const selected_locale = useCookie('selected_locale')
const { userCountryShopAvailable, refresh: refreshUserCountry } =
  useCountryRedirect({ options: { immediate: false } })

// The country lookup is deliberately client-only: the SSR HTML/payload is
// shared between users by the route cache (see `utils/ssrCache/index.ts`),
// whose key does not include the requesting IP. Resolving on the server
// would bake one user's geo detection into the cached payload for every
// other visitor of the same path. The modal owns the fetch so that the
// data is guaranteed to be loaded before the open/close decision (the
// layout's `fetchOnNavigation` would otherwise skip or fire-and-forget it).
onMounted(async () => {
  await refreshUserCountry()

  const cookieMissingOrDifferent =
    selected_locale.value === undefined ||
    (typeof selected_locale.value === 'string' &&
      selected_locale.value !== i18n.locale.value)

  setLocaleRedirectModal(
    userCountryShopAvailable.value && cookieMissingOrDifferent,
  )
})

const close = () => {
  setLocaleRedirectModal(false)
}

const showModal = computed(() => isLocaleRedirectModalOpen.value)
</script>
